<template>
  <v-app color="primary">
    <v-main>
      <NavBar v-if="isAuth" />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
export default {
  name: "App",
  components: {
    NavBar,
  },
  computed: {
    isAuth() {
      return this.$route.matched.some((record) => record.meta.requiresAuth);
    },
  },
};
</script>

<style>
@import url("@/assets/css/style.css");
</style>
